const moment = require('moment-timezone');
import { find } from 'lodash';
import { groups } from '@/static/time-zones.json';

export function isToday(date) {
  return date.isSame(new Date(), 'day');
}

export function isPastDate(date) {
  return date.isBefore(new Date(), 'day');
}

export function getLuminance(color) {
  const hasFullSpec = color.length == 7;
  const mask = color.substr(1).match(hasFullSpec ? /(\S{2})/g : /(\S{1})/g);

  const r = parseInt(mask[0] + (hasFullSpec ? '' : mask[0]), 16);
  const g = parseInt(mask[1] + (hasFullSpec ? '' : mask[1]), 16);
  const b = parseInt(mask[2] + (hasFullSpec ? '' : mask[2]), 16);

  return ((r*299)+(g*587)+(b*114))/1000;
}

export function formattedTime(time, zone, locale) {
  const result = moment.utc(time)
    .tz(zone)
    .locale(locale)
    .format('LLLL');

  return result;
}

export function formatSecondsAsDuration(seconds) {
  const durationMinutes = seconds / 60;
  const hour = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;
  const hourString = hour != 0 ? `${hour}h` : '';
  const minuteString = minutes != 0 ? `${minutes}m` : '';
  const timeDuration = `${hourString} ${minuteString}`.trim()
  return `(${timeDuration})`;
}

export function getCurrentTimeZone(predefined) {
  let result = find(ZONES_STATIC, { tzCode: predefined || moment.tz.guess() });

  if (!result) {
    result = find(ZONES_STATIC, { offset: moment().format('Z') });
  }

  return result;
}

export const ZONES_STATIC = groups.map(z => z.timeZones).flat().map(z => {
  return {tzCode: z.value, offset: z.offset};
});

export function getSearchParamAsArray(searchParams, name) {
  const searchParam = searchParams.get(name);
  return searchParam ? searchParam.split(',') : [];
}
